// extracted by css-extract-rspack-plugin
export default {"launcher":"global-styles_launcher__KptO+"};